import { render, staticRenderFns } from "./ParametrizacaoCampoUsuario.vue?vue&type=template&id=7d664014&scoped=true"
import script from "./ParametrizacaoCampoUsuario.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoCampoUsuario.vue?vue&type=script&lang=js"
import style0 from "./ParametrizacaoCampoUsuario.vue?vue&type=style&index=0&id=7d664014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d664014",
  null
  
)

export default component.exports